export enum RetailLocationsWorkspaceCapabilityAccessOperation {
    create = "d84242c6-c76c-40ae-a85e-b7edbc4e2b6e",
    read = "55a7cc50-e4c2-4d31-a03c-9ac5d5c1c26f",
    update = "ada46465-39bc-4072-a7b6-e3a7b8b2fda8",
    delete = "6b3fe486-2469-42fb-a676-9beaae73b0c6",
}
